var presentsWereChanged = false,
    presentsInitialized = false;

function checkPresentsCount($list) {
    const maxCount = parseInt($list.attr("data-max")); // Maximum allowed quantity
    let totalSelected = 0; // To keep track of total selected quantity

    // Calculate total selected quantity across all inputs
    $list.find(".c-form__quantity .c-form__input").each(function () {
        totalSelected += parseInt($(this).val()) || 0;
    });

    // Disable or enable inputs based on total selected quantity
    $list.find(".c-form__quantity .c-form__input").each(function () {
        const maxStock = parseInt($(this).attr("data-stock")); // Stock limit for this item
        const currentValue = parseInt($(this).val()) || 0;

        let remainingStock = maxCount - (totalSelected - currentValue); // Remaining stock available for other inputs

        if (remainingStock < 0) {
            remainingStock = 0;
        }

        $(this).attr("max", Math.min(remainingStock, maxStock)); // Set the max value

        // If the remaining stock is 0 and this input is empty, disable it
        if (remainingStock === 0 && currentValue === 0) {
            console.log("Disabling input due to stock limit");
            $(this).siblings(".is-increment, .is-decrement").prop("disabled", true);
            $(this).prop("disabled", true);
        } else {
            $(this).prop("disabled", false);
            $(this)
                .siblings(".is-decrement")
                .prop("disabled", currentValue <= 0);
            $(this)
                .siblings(".is-increment")
                .prop("disabled", currentValue >= maxStock || currentValue >= remainingStock);
        }
    });
}

$(function () {
    $(document).on("shown.bs.modal", "#up-sell, #present-modal", function () {
        var $form = $("#presentForm");

        $(".c-presents__list").each(function () {
            checkPresentsCount($(this));
        });

        if ($form.length > 0 && !presentsInitialized) {
            $("body").on("click", ".c-form__quantity .c-btn", function () {
                var $input = $(this).siblings("input.c-form__input");
                $input.trigger("change"); // Decrease value and trigger 'change' event
            });

            $("body").on("change", "#presentForm .c-presents__list .c-form__input", function () {
                var $list = $(this).parents(".c-presents__list"),
                    maxStockMsg = $list.attr("data-msg"),
                    maxStock = $(this).attr("data-stock"),
                    actualValue = $(this).val(),
                    notifyMe = $(this).attr("data-notify-me");

                if (parseInt(maxStock) === parseInt(actualValue)) {
                    if (parseInt(notifyMe) === 1) {
                        Eshop.alert(maxStockMsg, { type: "warning" });
                    }

                    $(this).attr("data-notify-me", 1);
                } else {
                    $(this).attr("data-notify-me", 0);
                }

                checkPresentsCount($list);

                presentsWereChanged = true;
            });

            $("body").on("click", "#up-sell .c-btn--cart", function (event) {
                if (presentsWereChanged) {
                    var url = $(this).attr("href");

                    event.preventDefault();

                    // showPreloader();

                    Form.ajaxPost(
                        $form,
                        function (data) {
                            window.location = url;
                        },
                        "json"
                    );
                }
            });

            $("body").on("click", "#present-modal .c-btn--cart", function (event) {
                event.preventDefault();

                if (presentsWereChanged) {
                    var url = $(this).attr("href");

                    // showPreloader();

                    Form.ajaxPost(
                        $form,
                        function (data) {
                            window.location = url;
                        },
                        "json"
                    );
                } else {
                    $("#present-modal").modal("hide");
                }
            });

            presentsInitialized = true;
        }
    });

    $(document).on("hide.bs.modal", "#up-sell", function () {
        if (presentsWereChanged) {
            var $form = $("#presentForm");

            presentsWereChanged = false;

            Form.ajaxPost($form, function (data) {}, "json");
        }
    });
});
